import React from "react";
import { Modal } from "react-bootstrap";

export default function AdminAttendanceReport({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      
      <Modal.Header closeButton>
        <Modal.Title>Attendance</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* TOP INFO */}
        <div className="attendance-top">
          <div>
            <p className="label">Date</p>
            <h6>15 Apr 2025</h6>
          </div>
          <div>
            <p className="label">Punch in at</p>
            <h6>09:00 AM</h6>
          </div>
          <div>
            <p className="label">Punch out at</p>
            <h6>06:45 PM</h6>
          </div>
          <div>
            <p className="label">Status</p>
            <h6>Present</h6>
          </div>
        </div>

        {/* STATS */}
        <div className="attendance-stats mt-4">

          <div>
            <p>Total Working hours</p>
            <h5>12h 36m</h5>
          </div>

          <div>
            <p className="green-dot">Productive Hours</p>
            <h5>08h 36m</h5>
          </div>

          <div>
            <p className="yellow-dot">Break hours</p>
            <h5>22m 15s</h5>
          </div>

          <div>
            <p className="blue-dot">Overtime</p>
            <h5>02h 15m</h5>
          </div>

        </div>

        {/* TIMELINE */}
        <div className="timeline mt-4">
          <div className="bar green"></div>
          <div className="bar yellow"></div>
          <div className="bar green"></div>
          <div className="bar yellow"></div>
          <div className="bar green"></div>
          <div className="bar blue"></div>
        </div>

      </Modal.Body>
    </Modal>
  );
}